import { Icon, IconProps } from '@hologram-dimension/icon';
import clsx from 'clsx/lite';
import type { ColorTokenNames } from '@hologram-dimension/tokens/colors';
import styles from './IconWrapper.module.css';

interface IconWrapperProps {
  size?: 'small' | 'large';
  colorVariant?: string;
  iconName: IconProps['name'];
  elementRef?: React.Ref<HTMLDivElement>;
  diminished?: boolean;
}
const IconWrapper = (props: IconWrapperProps) => {
  const {
    size = 'large',
    colorVariant = 'default',
    iconName,
    elementRef,
    diminished = false,
  } = props;
  let fill: ColorTokenNames | undefined;
  if (colorVariant === 'black') {
    fill = 'DdsColorTextPrimaryOninverse';
  } else if (diminished) {
    fill = 'DdsColorTextDiminishedOndefault';
  }
  return (
    <div
      className={clsx(
        styles.iconWrapper,
        size === 'small' && styles.iconWrapperSmall,
        (styles as any)[colorVariant]
      )}
      ref={elementRef && elementRef}
    >
      <Icon name={iconName} size={size === 'small' ? 'small' : undefined} fill={fill} />
    </div>
  );
};

export default IconWrapper;
